module.exports = __webpack_public_path__ + "img/glasses_female_round.70a2e724.png";